// extracted by mini-css-extract-plugin
export default {"mainButton":"Button_mainButton__yKca0","primeButton":"Button_primeButton__ga3Bm","ctaButton":"Button_ctaButton__D1yiW"};